export { default } from './StoreDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreDetail/index.js